import { render, staticRenderFns } from "./QuickLinkDetailTable.vue?vue&type=template&id=09590af2"
import script from "./QuickLinkDetailTable.vue?vue&type=script&lang=js"
export * from "./QuickLinkDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports